import Alert from 'bootstrap/js/dist/alert';
import Button from 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';


//Popover
import Popover from 'bootstrap/js/dist/popover';

const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
const popovers = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl, {
  html: true
}));
window.Popover = Popover;
window.popovers = popovers;


//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';

//ToolTip

import Tooltip from 'bootstrap/js/dist/tooltip';

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
window.Tooltip = Tooltip;

import "@/app-contacts/js/app.js"

//Datepicker
import Datepicker from 'vanillajs-datepicker/Datepicker';

//main SCSS
import app from "@scss/app.scss";